export enum BoundingBoxShortcutType {
    SPAWN_BOUNDING_BOX = "SPAWN_BOUNDING_BOX", // no meta
    SPAWN_ANNOTATION_DOT = "SPAWN_ANNOTATION_DOT", // no meta
    SWITCH_TO_NEXT_SPAWNLABLE = "SWITCH_TO_NEXT_SPAWNABLE", // no meta
    SWITCH_TO_PREVIOUS_SPAWNLABLE = "SWITCH_TO_PREVIOUS_SPAWNABLE", // no meta
    DELETE_ANNOTATION_DOT = "DELETE_ANNOTATION_DOT", // no meta
    CLEAR_ALL = "CLEAR_ALL", // no meta
}